export const SITE_LOGO = `${process.env.PUBLIC_URL}/assets/images/qtech-logo.png`;
export const SITE_LOGO_WHITE = `${process.env.PUBLIC_URL}/assets/images/white-logo.png`;
export const SITE_REPRESENTATIVE_IMAGE = `${process.env.PUBLIC_URL}/assets/images/about/qtech-representative.png`;
export const LETS_TALK_IMAGE = `${process.env.PUBLIC_URL}/assets/images/contact/lets-talk-reception.png`;
export const SERVICES_HELP_IMAGE = `${process.env.PUBLIC_URL}/assets/images/contact/services-help.png`;
export const CONTACT_GET_IN_TOUCH_IMAGE = `${process.env.PUBLIC_URL}/assets/images/contact/contact-get-in-touch.png`;
export const BENEFIT_SECTION_IMAGE = `${process.env.PUBLIC_URL}/assets/images/about/benefit-office.png`;
export const MANAGEMENT_SECTION_IMAGE = `${process.env.PUBLIC_URL}/assets/images/about/management-meeting.png`;
export const ADMIN_PANEL_URL =
  process.env.REACT_APP_ADMIN_URL || 'https://api.qtechcontracting.com/admin';
